import React from 'react'

import { getSubdomain } from '../../../../../utils/helpers/url'
import { useForm } from '../../../../../packages/kiti/components/form/form/FormHandler'
import D4signGenPdfAndSendToSignSentence from './d4sign/GenPDFAndSendToSignSentence'
import D4signSendToSignersSentence from './d4sign/d4signSendToSignersSentence'
import EmailSentence from './email/EmailSentence'
import GoogleCalendarSentence from './google_calendar/GoogleCalendarSentence'
import InsertPlaceSentence from './insertPlace/InsertPlaceSentence'
import InsertServiceOrderSentence from './insertServiceOrder/InsertServiceOrderSentence'
import InsertServiceOrdersSentence from './insertServiceOrders/InsertServiceOrdersSentence'
import InsertUserSentence from './insertUser/InsertUserSentence'
import SlackSentence from './slack/SlackSentence'
import TwilioSendSmsSentence from './twilio/TwilioSendSmsSentence'
import TwilioSendWhatAppSentence from './twilio/TwilioSendWhatAppSentence'
import ChatProSendWhatsAppSentence from './chat_pro/ChatProSendWhatsAppSentence'
import WebhookSentence from './webhook/WebhookSentence'
import D4signAttachAtOriginSentence from './d4sign/d4signAttachAtOrigin'
import LockPlaceSentence from './nonCompliance/LockPlaceSentence'
import SetAvailabilityStatusSentence from './availability/SetAvailabilityStatusSentence'
import UpdatePlaceSentence from './updatePlace/UpdatePlaceSentence'
import SlackSentenceSendDm from './slack/SlackSentenceSendDm'
import UpdateServiceOrderNameSentence from './updateServiceOrderName/UpdateServiceOrderNameSentence'
import UpdateServiceOrderUserOrGroup from './updateServiceOrderUserOrGroup/UpdateServiceOrderUserOrGroup'
import UpdateAssetSentence from './updateAsset/UpdateAssetSentence'
import UpdateStatusSentence from './updateStatus/UpdateStatusSentence'
import UpdateChildServiceOrderSentence from './updateChildServiceOrder/UpdateChildServiceOrderSentence'
import CompleteServiceOrdersSentence from './completeServiceOrders/CompleteServiceOrdersSentence'
import CompleteNonCompliancesSentence from './completeNonCompliances/CompleteNonCompliancesSentence'
import AssignTagSentence from './tags/AssignTagSentence'

const SCHEDULE_INSERT_WORKSPACES = ['v2', 'arehs']

const DynamicSentence = () => {
  const form = useForm()
  const workspace = getSubdomain()
  const canUseScheduleInsert = SCHEDULE_INSERT_WORKSPACES.includes(workspace)

  switch (form.action) {
    case 'email':
      return <EmailSentence />

    case 'webhook':
      return <WebhookSentence />

    case 'slack_channel_message':
      return <SlackSentence />

    case 'slack_direct_message':
      return <SlackSentenceSendDm />

    case 'google_calendar_insert_event':
      return <GoogleCalendarSentence />

    case 'insert_service_order':
      return <InsertServiceOrderSentence />

    case 'insert_service_orders':
      return <InsertServiceOrdersSentence />

    case 'complete_service_orders':
      return <CompleteServiceOrdersSentence />

    case 'complete_non_compliances':
      return <CompleteNonCompliancesSentence />

    case 'schedule_insert_service_order':
      return canUseScheduleInsert ? <InsertServiceOrderSentence isFuture /> : null

    case 'schedule_insert_service_orders':
      return canUseScheduleInsert ? <InsertServiceOrdersSentence isFuture /> : null

    case 'update_service_order_name':
      return <UpdateServiceOrderNameSentence />

    case 'update_service_order_user_or_group':
      return <UpdateServiceOrderUserOrGroup />

    case 'insert_place':
      return <InsertPlaceSentence />

    case 'insert_user':
      return <InsertUserSentence />

    case 'd4sign_send_to_sing':
      return <D4signSendToSignersSentence />

    case 'd4sign_attach_document':
      return <D4signAttachAtOriginSentence />

    case 'd4sign_gen_pdf_and_send_to_sing':
      return <D4signGenPdfAndSendToSignSentence />

    case 'whatsapp_by_twilio':
      return <TwilioSendWhatAppSentence />

    case 'whatsapp_by_chat_pro':
      return <ChatProSendWhatsAppSentence />

    case 'sms_by_twilio':
      return <TwilioSendSmsSentence />

    case 'place_lock':
      return <LockPlaceSentence />

    case 'set_availability_status':
      return <SetAvailabilityStatusSentence />

    case 'update_place':
      return <UpdatePlaceSentence />

    case 'update_asset':
      return <UpdateAssetSentence />

    case 'update_status':
      return <UpdateStatusSentence />

    case 'update_parent_status':
      return <UpdateStatusSentence />

    case 'update_child_service_order':
      return <UpdateChildServiceOrderSentence />

    case 'assign_tag':
      return <AssignTagSentence />

    default:
      return false
  }
}

export default DynamicSentence
